import { render } from "./CustomCarousel.vue?vue&type=template&id=589798be&scoped=true"
import script from "./CustomCarousel.vue?vue&type=script&lang=js"
export * from "./CustomCarousel.vue?vue&type=script&lang=js"

import "./CustomCarousel.vue?vue&type=style&index=0&id=589798be&lang=stylus&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-589798be"]])

export default __exports__